import { z } from "zod";

export const passwordSchema = z
  .string()
  .min(10, "Минимум 10 символов")
  .max(128, "Слишком длинный пароль");

export const registerSchema = z.object({
  name: z.string().trim().min(2, "Укажите имя").max(80, "Слишком длинное имя"),
  email: z.email("Укажите корректный email"),
  password: passwordSchema,
});

export const loginSchema = z.object({
  email: z.email("Укажите корректный email"),
  password: z.string().min(1, "Введите пароль"),
});

export const emailSchema = z.object({
  email: z.email("Укажите корректный email"),
});

export const resetSchema = z.object({
  password: passwordSchema,
});

export const profileSchema = z.object({
  name: z.string().trim().min(2, "Укажите имя").max(80, "Слишком длинное имя"),
});

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, "Введите текущий пароль"),
  newPassword: passwordSchema,
});

export const businessTypeSchema = z.enum([
  "REPAIR",
  "FURNITURE",
  "WINDOWS",
  "ENGINEERING",
  "LANDSCAPE",
  "EVENTS",
  "OTHER",
]);

export const onboardingNameSchema = z.object({
  name: z.string().trim().min(2, "Укажите название").max(120, "Слишком длинное название"),
});

export const organizationSchema = z.object({
  name: z.string().trim().min(2, "Укажите название").max(120, "Слишком длинное название"),
  phone: z.string().trim().max(40, "Слишком длинный телефон"),
  email: z.union([z.literal(""), z.email("Укажите корректный email")]),
  website: z.union([z.literal(""), z.url("Укажите адрес сайта с https://")]),
  description: z.string().trim().max(500, "Описание не длиннее 500 символов"),
  brandColor: z.union([
    z.literal(""),
    z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Цвет в формате #RRGGBB"),
  ]),
});
